<!-- iOS Update Notice - Shows for unsupported iOS versions -->
<app-ios-update-notice *ngIf="showIosUpdateNotice" [currentVersion]="currentIosVersion" [minSupportedVersion]="minSupportedIosVersion">
</app-ios-update-notice>

<!-- Main App Content - Only shows if iOS version is supported -->
<div *ngIf="!showIosUpdateNotice">
  <router-outlet></router-outlet>
  <ngx-ui-loader></ngx-ui-loader>

  <!--Start Session Timeout Modal -->
  <div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="dialog-child-name" class="modal-title pull-left">You Have Been Idle!</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="hideChildModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          {{ idleState }}
        </div>
      </div>
    </div>
  </div>

  <!-- <div bsModal #updateModal="bs-modal" class="modal" 
    role="dialog" aria-labelledby="dialog-child-name">  
    <div class="update-notifications">

   <div class="modal-body" style="padding-top: 20px;">
     <p>KiwiWrite has been updated and needs to be reloaded. If you would like to learn about the updates, please visit<a href="kiwiwrite.com/latest-updates" target="_blank" >kiwiwrite.com/latest-updates</a></p>
   </div>
   <button type="button" class="btn btn-secondary">Reload</button>
  </div>
  </div> -->

  <ng-template #template>
    <div class="update-notifications text-center">
      <div class="modal-body" style="padding-top: 20px">
        <p style="font-size: 18px; color: #000000">
          KiwiWrite has been updated and needs to be reloaded. If you would like to learn about the updates, please visit
          <a href="https://www.kiwiwrite.com/latest-updates" target="_blank"> kiwiwrite.com/latest-updates</a>
        </p>
      </div>
      <button type="button" *ngIf="isForceUpdate" class="btn reload-btn" (click)="updateNoticeReloadOnClick('Reload')">Reload</button>
      <button type="button" *ngIf="!isForceUpdate" class="btn reload-btn" (click)="updateNoticeReloadOnClick('Cancel')">Okay</button>
    </div>
  </ng-template>
  <!--End Session Timeout Modal -->

  <!--Global footer start-->
  <footer class="global-footer" *ngIf="showFooter">
    <div class="_footer-section">
      <div class="_subscription-text" *ngIf="showSubscriptionMessage">
        <p>
          {{ 'subscriptionModalDescription' | translate }}
        </p>
      </div>
      <div class="_copywrite">
        <p>{{ 'copyright-version-two' | translate }}</p>
      </div>
    </div>
  </footer>
</div>
